module.exports = __webpack_public_path__ + "static/media/img_notice_null.b3049be7.svg";